<!-- eslint-disable no-plusplus -->
<template>
  <el-card
    id="qualityTaskForm"
    class="normal h-full"
    :body-style="{ padding: '20px', height: '100%' }"
  >
    <div v-if="isShowTab" class="font-bold mb-10px">
      {{ $t('详情') }}
      <el-button @click="goBack" class="float-right">后退</el-button>
    </div>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      style="height: calc(100% - 34px)"
    >
      <!--基本信息-->
      <el-tab-pane :label="$t('basicInformation')" name="info">
        <el-col :span="!!taskId ? 12 : 24">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            style="width: 500px; margin: 0 auto"
            size="small"
            :disabled="isShowTab"
          >
            <el-form-item :label="$t('任务名称')" prop="name">
              <el-input
                v-model="ruleForm.name"
                @blur="changeName"
                :placeholder="$t('请输入任务名称')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('质检源')" prop="dataSourceId">
              <el-select
                class="w-full"
                v-model="ruleForm.dataSourceId"
                @change="changeDataSource"
                :placeholder="$t('pleaseSelect')"
                filterable
                clearable
                :disabled="type !== 'add'"
              >
                <el-option
                  v-for="(item, index) in dataSourceList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('数据源模型')" prop="standardId">
              <el-select
                v-model="ruleForm.standardId"
                clearable
                filterable
                class="w-full"
                placeholder
                disabled
              >
                <el-option
                  v-for="item in standardList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('执行频度')" prop="cronExpressionId">
              <el-select
                class="w-full"
                v-model="ruleForm.cronExpressionId"
                :placeholder="$t('pleaseSelect')"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in cronList"
                  :key="index"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!--新增编辑时显示的字段-->
            <template v-if="!taskId">
              <el-form-item :label="$t('任务状态')" prop="isEffective">
                <el-select
                  class="w-full"
                  v-model="ruleForm.isEffective"
                  :placeholder="$t('请选择任务状态')"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="(item, index) in statusList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('是否重试')" prop="isNeedRetry">
                <el-checkbox v-model="ruleForm.isNeedRetry"></el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('重试次数')" prop="retryCount">
                <el-input
                  v-model="ruleForm.retryCount"
                  :placeholder="$t('请输入次数')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="间隔时间" prop="retryIntervalTime">
                <el-input
                  v-model="ruleForm.retryIntervalTime"
                  :placeholder="$t('请输入间隔时间')"
                  clearable
                ></el-input>
              </el-form-item>
            </template>
            <!--查看详情时显示的字段-->
            <template v-else>
              <el-form-item :label="$t('总运行次数')" prop="totalRunCount">
                <el-input v-model="ruleForm.totalRunCount" placeholder clearable></el-input>
              </el-form-item>
              <el-form-item :label="$t('失败次数')" prop="errorRunCount">
                <el-input v-model="ruleForm.errorRunCount" placeholder clearable></el-input>
              </el-form-item>
              <el-form-item :label="$t('上次运行时间')" prop="lastRunTime">
                <el-input v-model="ruleForm.lastRunTime" placeholder clearable></el-input>
              </el-form-item>
              <el-form-item :label="$t('失败原因')" prop="errorMessage">
                <el-input
                  v-model="ruleForm.errorMessage"
                  placeholder
                  type="textarea"
                  rows="3"
                  clearable
                ></el-input>
              </el-form-item>
            </template>
          </el-form>
        </el-col>
        <el-col v-if="!!taskId" :span="12">
          <messageForm :messageSetting="messageSetting" :taskId="taskId"></messageForm>
        </el-col>
      </el-tab-pane>

      <!--关联表-->
      <el-tab-pane :label="$t('关联表')" name="relation" class="h-full">
        <el-row>
          <el-select
            v-if="!taskId"
            class="mr-10px"
            v-model="relationSearch.subjectDomainId"
            @change="changeRelation"
            :placeholder="$t('请选择业务主题域')"
            :filter-method="filterSelect"
            size="small"
            filterable
            clearable
          >
            <el-tree
              ref="tree"
              :data="treeData"
              :props="defaultProps"
              default-expand-all
              :filter-node-method="filterNode"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-option :label="`${data.name}（${data.code}）`" :value="data.id"></el-option>
              </span>
            </el-tree>
          </el-select>
          <el-input
            class="mr-10px w-200px"
            v-model="relationSearch.keyword"
            size="small"
            :placeholder="$t('请输入表名或中文名称')"
            clearable
          ></el-input>
          <el-button type="primary" @click="getRelationData">{{ $t('search') }}</el-button>
        </el-row>
        <el-row class="mt-20px" style="height: calc(100% - 57px)">
          <vxe-table
            :loading="loading.relationTable"
            ref="relationTable"
            :height="taskId ? '100%' : 420"
            :data="relationTableData"
            class="w-full"
            border
            @checkbox-change="handleSelectionChange"
            @cell-dblclick="handleRowDblClick"
            :checkbox-config="relationCheckConfig"
            resizable
            show-overflow="title"
          >
            <vxe-table-column
              v-if="!taskId"
              type="checkbox"
              width="60"
              align="center"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              field="tableName"
              :title="$t('表名')"
              class-name="cell-center"
              header-class-name="cell-center"
              min-width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="name"
              :title="$t('实体中文名称')"
              class-name="cell-center"
              header-class-name="cell-center"
              minWidth="120"
            ></vxe-table-column>
            <vxe-table-column
              field="sourceSystem"
              :title="$t('来源系统')"
              class-name="cell-center"
              header-class-name="cell-center"
              minWidth="100"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源系统',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="sourceDataTableName"
              :title="$t('来源数据表')"
              class-name="cell-center"
              header-class-name="cell-center"
              minWidth="100"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源数据表',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="lastModifiedUserName"
              :title="$t('最近修改人')"
              class-name="cell-center"
              header-class-name="cell-center"
              minWidth="100"
            ></vxe-table-column>
            <vxe-table-column
              field="description"
              :title="$t('实体说明')"
              class-name="cell-center"
              header-class-name="cell-center"
              minWidth="100"
            ></vxe-table-column>
          </vxe-table>
        </el-row>
      </el-tab-pane>

      <!--规则-->
      <el-tab-pane :label="$t('规则')" name="rule" class="h-full">
        <el-row>
          <el-select
            class="mr-10px"
            v-model="ruleSearch.ruleName"
            :placeholder="$t('规则类型')"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="item in ruleTypeList"
              :key="item.id"
              :label="item.displayName"
              :value="item.displayName"
            ></el-option>
          </el-select>
          <el-input
            class="mr-10px w-200px"
            v-model="ruleSearch.keyword"
            size="small"
            :placeholder="$t('请输入属性中文名称')"
            clearable
          ></el-input>
          <el-button type="primary" @click="getRuleList" clearable>{{ $t('search') }}</el-button>
        </el-row>
        <el-row class="mt-20px" style="height: calc(100% - 57px)">
          <vxe-table
            ref="ruleTable"
            :loading="loading.ruleTable"
            :height="taskId ? '100%' : 400"
            :data="ruleTableData"
            class="w-full"
            border
            resizable
            show-overflow="title"
            @checkbox-change="selectRuleCheckbox"
            @checkbox-all="selectRuleCheckbox"
          >
            <vxe-table-column
              v-if="!taskId"
              type="checkbox"
              width="60"
              align="center"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              field="tableName"
              :title="$t('表名')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              field="className"
              :title="$t('实体中文名称')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              :title="$t('属性英文名称')"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '英文名称',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="name"
              :title="$t('属性中文名称')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              field="referenceDataValue"
              :title="$t('参考数据')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              :title="$t('来源系统')"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源系统',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              :title="$t('来源数据表')"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源数据表',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              :title="$t('来源数据字段')"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源数据字段',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              :title="$t('来源PK')"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源字段是否主键',
                      }),
                      'refValue'
                    )
                  }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="ruleName"
              :title="$t('规则类型')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              field="ruleContent"
              :title="$t('规则内容')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              field="ruleDescription"
              :title="$t('规则描述')"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
          </vxe-table>
        </el-row>
      </el-tab-pane>

      <!--消息设置-->
      <el-tab-pane v-if="!isShowTab" :label="$t('消息设置')" name="message">
        <messageForm ref="messageSetting" :messageSetting="messageSetting"></messageForm>
      </el-tab-pane>

      <!--规则问题情况-->
      <el-tab-pane :label="$t('规则问题情况')" name="problem" v-if="isShowTab" class="h-full">
        <el-row class="flex">
          <el-select
            class="mr-10px"
            v-model="problemSearch.select"
            @change="changeProblemSelect"
            :placeholder="$t('pleaseSelect')"
            value-key="id"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in runRecordList"
              :key="index"
              :label="item.endTime"
              :value="item"
            ></el-option>
          </el-select>
          <el-input
            class="mr-10px"
            v-model="problemSearch.keyword"
            style="width: 200px"
            size="small"
            :placeholder="$t('规则描述或规则类型')"
            clearable
          ></el-input>
          <el-button type="primary" size="small" @click="getProblemList">{{
            $t('search')
          }}</el-button>
          <el-button type="primary" size="small" @click="openDetail('read', 0)">{{
            $t('view')
          }}</el-button>
          <el-button type="primary" size="small" @click="readTaskReport">{{
            $t('报告')
          }}</el-button>
          <el-button size="small" @click="exportRuleInfoList">{{ $t('export') }}</el-button>
        </el-row>
        <el-row class="mt-20px mb-10px table-height">
          <el-table
            v-loading="loading.ruleProblemTable"
            height="100%"
            :data="problemTableData"
            class="w-full"
            border
            highlight-current-row
            @current-change="changeDetail"
          >
            <el-table-column
              type="index"
              :label="$t('序号')"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column prop="content" :label="$t('规则内容')"></el-table-column>
            <el-table-column prop="ruleName" :label="$t('规则类型')"></el-table-column>
            <el-table-column prop="description" :label="$t('规则描述')"></el-table-column>
            <el-table-column prop="checkCount" :label="$t('检查数')"></el-table-column>
            <el-table-column prop="problemCount" :label="$t('问题数')"></el-table-column>
            <el-table-column prop="ratio" :label="$t('问题比例')"></el-table-column>
            <el-table-column prop="impactClassLibrary" :label="$t('影响类库')"></el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <el-pagination
            class="r"
            background
            @size-change="problemSizeChange"
            @current-change="problemPageChange"
            :current-page.sync="problem.pageNo"
            :page-sizes="$pageSizeAll"
            :page-size.sync="problem.pageSize"
            layout="->, total, sizes, prev, pager, next"
            :total="problem.total"
          ></el-pagination>
        </el-row>
      </el-tab-pane>

      <!--字段明细情况-->
      <el-tab-pane :label="$t('字段明细情况')" name="field" v-if="isShowTab" class="h-full">
        <el-row class="flex">
          <el-select
            class="mr-10px"
            v-model="fieldSearch.select"
            @change="getFieldDetail"
            :placeholder="$t('pleaseSelect')"
            size="small"
            value-key="id"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in runRecordList"
              :key="index"
              :label="item.endTime"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            class="mr-10px"
            v-model="fieldSearch.bank"
            :placeholder="$t('pleaseSelect')"
            size="small"
            @change="getFieldDetail"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in classBank"
              :key="index"
              :label="item.tableName"
              :value="item.classId"
            ></el-option>
          </el-select>
          <el-input
            class="mr-10px"
            :placeholder="$t('搜索类别代码或类别名称')"
            v-model="fieldSearch.keyword"
            style="width: 200px"
            size="small"
            clearable
          ></el-input>
          <el-button @click="getFieldDetail" type="primary" size="small">{{
            $t('search')
          }}</el-button>
          <el-button type="primary" size="small" @click="openDetail('read', 1)">{{
            $t('view')
          }}</el-button>
          <el-button type="primary" size="small" @click="readTaskReport">{{
            $t('报告')
          }}</el-button>
          <el-button size="small" @click="exportFieldInfoList">{{ $t('export') }}</el-button>
        </el-row>
        <el-row class="mt-20px mb-10px table-height">
          <el-table
            v-loading="loading.fieldTable"
            height="100%"
            ref="fieldTable"
            :data="fieldTableData"
            border
            highlight-current-row
            @current-change="changeDetail"
          >
            <el-table-column
              type="index"
              :label="$t('序号')"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('实体中文名称')">
              <template slot-scope="scope">
                <span>{{ _.get(scope.row.classAttribute, 'className') }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('属性英文名称')">
              <template slot-scope="scope">
                <span>{{ _.get(scope.row.classAttribute, 'code') }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('属性中文名称')">
              <template slot-scope="scope">
                <span>{{ _.get(scope.row.classAttribute, 'name') }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('来源系统')">
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.classAttribute.dynamicColumnData, {
                        actualAttributeColumnName: '来源系统',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('来源数据表')">
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.classAttribute.dynamicColumnData, {
                        actualAttributeColumnName: '来源数据表',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('来源数据字段')">
              <template slot-scope="scope">
                <span>
                  {{
                    _.get(
                      _.find(scope.row.classAttribute.dynamicColumnData, {
                        actualAttributeColumnName: '来源数据字段',
                      }),
                      'value'
                    )
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="problemCount"
              :label="$t('问题总数')"
            ></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('问题数')">
              <el-table-column
                v-for="(col, index) in fieldHeader"
                :key="index"
                :label="col.ruleName"
              >
                <template slot-scope="scope">
                  <span>
                    {{
                      _.get(
                        _.find(scope.row.problemList, { ruleName: col.ruleName }),
                        'problemCount'
                      )
                    }}
                  </span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <el-pagination
            class="r"
            background
            @size-change="fieldSizeChange"
            @current-change="fieldPageChange"
            :current-page.sync="field.pageNo"
            :page-sizes="$pageSizeAll"
            :page-size.sync="field.pageSize"
            layout="->, total, sizes, prev, pager, next"
            :total="field.total"
          ></el-pagination>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-row class="text-center mt-20px" v-if="!taskId">
      <el-button size="small" @click="close">{{ $t('cancel') }}</el-button>
      <el-button type="primary" size="small" :loading="loading.save" @click="submitForm">{{
        $t('save')
      }}</el-button>
    </el-row>

    <!-- 设置关联表弹框 -->
    <el-dialog title="设置属性" :visible.sync="dialogVisible" width="1000px" append-to-body>
      <el-table border class :data="inputData" height="400px">
        <el-table-column label="属性" prop="classAttributeId">
          <template slot-scope="scope">
            <el-select
              :disabled="isShowTab"
              filterable
              clearable
              v-model="scope.row.classAttributeId"
              class="!w-full"
            >
              <el-option
                v-for="(item, index) in attributeList"
                :label="item.name"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="条件" prop="operator">
          <template slot-scope="scope">
            <el-select
              :disabled="isShowTab"
              filterable
              clearable
              v-model="scope.row.operator"
              class="!w-full"
            >
              <el-option
                v-for="(item, index) in conditionList"
                :label="item.text"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="值" prop="text">
          <template slot-scope="scope">
            <el-input
              size="small"
              :disabled="isShowTab"
              v-model="scope.row.text"
              :placeholder="$t('请输入参数代码')"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')" width="200" v-if="!isShowTab">
          <template slot="header">
            <el-button size="mini" @click="addInputCode()">新增</el-button>
          </template>
          <template slot-scope="scope">
            <el-button size="mini" @click="deleteInputCode(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer" v-if="!isShowTab">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveSettings">保存</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import StdClassTreeService from '@/services/StdClassTreeService'
import StandardManagementService from '@/services/common/StandardManagementService'
import QualityTaskService from '@/services/QualityTaskService'
import DataRuleSettingService from '@/services/DataRuleSettingService'
import DataSourceService from '@/services/DataSourceService'
import stdClassListService from '@/services/stdClassListService'
import dayjs from 'dayjs'
import messageForm from './messageForm'

export default {
  name: 'qualityTaskForm',
  mixins: [],
  components: {
    messageForm,
  },
  props: {
    type: String,
    detailInfo: Object,
  },
  data() {
    return {
      activeName: 'info', // info: 基本信息，relation：关联表，rule：规则，message：消息设置，problem：规则问题情况，field：字段明细情况
      loading: {
        init: false,
        save: false,
        relationTable: false,
        ruleTable: false,
        ruleProblemTable: false,
        fieldTable: false,
      },

      // 基本信息
      ruleForm: {},
      ruleFormCopy: {},
      rules: {
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        dataSourceId: [{ required: true, message: '请选择质检源', trigger: 'change' }],
        standardId: [{ required: true, message: '请选择数据源模型', trigger: 'change' }],
        cronExpressionId: [{ required: true, message: '请选择表达式', trigger: 'change' }],
        isEffective: [{ required: true, message: '请选择任务状态', trigger: 'change' }],
      },
      standardList: [],
      dataSourceList: [],
      cronList: [],
      statusList: [
        { name: '启动', value: true },
        { name: '停止', value: false },
      ],

      // 关联表
      filterText: '',
      relationCheckConfig: {
        showHeader: false,
        checkMethod: ({ row }) => {
          return !row.isChangeCheck
        },
      },
      treeData: [], // 标准库列表
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      relationSearch: {
        keyword: '',
        subjectDomainId: '', // 业务主题域id
      },
      relationTableData: [],
      checkRelationTable: [],

      // 规则
      entityList: [], // 实体列表
      ruleSearch: {
        stdId: '',
        entityId: '',
        keyword: '',
        ruleName: '',
      },
      ruleTableData: [],
      ruleTypeList: [],
      checkRuleTable: [],

      // 消息设置
      messageSetting: {
        noticeSettings: 2,
      },
      messageSettingCopy: {
        noticeSettings: 2,
      },

      // 规则问题情况
      runRecordList: [],
      problemSearch: {
        keyword: '',
      },
      problemTableData: [],
      problem: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      field: { pageNo: 1, pageSize: 15, total: 0 },
      currentDetail: null,
      // 字段明细情况
      fieldHeader: [],
      classBank: [],
      fieldSearch: {
        select: '',
        bank: '',
        keyword: '',
      },
      fieldTableData: [],
      detailId: '',
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      dialogVisible: false,
      inputData: [],
      conditionList: [],
      attributeList: [],
      editType: 'create',
      relationTableDataCurrentRow: {},
      settingSearch: {
        keyword: '',
      },
    }
  },
  computed: {
    isShowTab() {
      return !!this.$route.query.id
    },
    taskId() {
      return this.$route.query.id
    },
    isChange() {
      return (
        !_.isEqual(this.ruleForm, this.ruleFormCopy) ||
        !_.isEqual(this.messageSetting, this.messageSettingCopy)
      )
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  watch: {
    $route(newVal, oldVal) {
      // 从别的模块跳转过来，直接跳转到列表页(从质检报告过来除外)
      if (
        !_.includes(oldVal.path, '/dataQuality/qualityTask') &&
        _.includes(newVal.path, '/dataQuality/qualityTask') &&
        !_.includes(oldVal.path, '/dataQuality/taskReport')
      ) {
        this.$router.push(`${this.basePath}/dataQuality/qualityTask`)
        return
      }
      // 从质量任务管理列表页跳转过来，需要重新查询详情，并且将tab默认为【基本信息】
      if (
        oldVal.path === '/dataQuality/qualityTask' ||
        _.includes(oldVal.path, '/dataQuality/taskReport')
      ) {
        this.activeName = 'info'
        this.initData()
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    'relationSearch.subjectDomainId': {
      handler() {
        this.filterText = ''
      },
    },
  },
  methods: {
    goBack() {
      this.$router.push(`${this.basePath}/legacy-resource/data-quality-manage/quality-task`)
    },
    /**      通用方法 --start      */

    /**
     * @function 切换tab
     */
    async handleClick(val) {
      if (val.label === '关联表') {
        await this.getTreeList()
        this.getRelationData() // 获取关联表数据
      } else if (val.label === '规则') {
        this.getRuleList()
        this.getRuleType() // 获取规则类型
      } else if (val.label === '规则问题情况') {
        await this.getProblemSelect() // 获取下拉
        this.getProblemList()
      } else if (val.label === '字段明细情况') {
        await this.getProblemSelect()
        await this.getFieldSelect() // 获取下拉
        this.getFieldDetail()
      }
    },
    close() {
      this.$emit('closeDialog')
    },

    /**      通用方法 --end      */

    /**      基本信息 --start      */

    submitForm() {
      let valid1 = false
      let valid2 = false
      this.$refs.ruleForm.validate((valid) => {
        if (!valid && this.activeName === 'info') return
        valid1 = valid
      })
      this.$refs.messageSetting.$children[0].validate((valid) => {
        if (!valid && this.activeName === 'message') return
        valid2 = valid
      })
      if (!valid1 && this.activeName !== 'info') {
        this.$message.warning('请将基本信息内容补充完整')
        return
      }
      if (!valid2 && this.activeName !== 'message') {
        this.$message.warning('请将消息设置内容补充完整')
        return
      }
      if (valid1 && valid2) {
        // 任务状态为停止时，关联表和规则可以为空
        if (
          this.ruleForm.isEffective &&
          _.isEmpty(this.checkRelationTable) &&
          _.isEmpty(this.ruleForm.details)
        ) {
          this.$message.warning('请勾选关联表')
          return
        }
        // 任务状态为停止时，关联表和规则可以为空
        if (
          this.ruleForm.isEffective &&
          _.isEmpty(this.checkRuleTable) &&
          _.isEmpty(this.ruleForm.ruleDetails)
        ) {
          this.$message.warning('请勾选规则')
          return
        }
        if (_.isEmpty(this.messageSetting)) {
          this.$message.warning('消息设置不能为空')
          return
        }
        this.saveData()
      }
    },
    async saveData() {
      this.loading.save = true
      let res
      const params = {
        model: {
          ...this.ruleForm,
          cronExpressionValue: _.get(
            _.find(this.cronList, { id: this.ruleForm.cronExpressionId }),
            'data'
          ),
          messageSetting: {
            ...this.messageSetting,
            isSendDetails: this.messageSetting.isSendDetails ? 0 : 1,
          },
          recipient: this.messageSetting.recipient,
        },
      }
      console.log(params, 'params')
      if (this.ruleForm.id) {
        res = await QualityTaskService.update(params)
      } else {
        res = await QualityTaskService.add(params)
      }
      if (res && res.code === 0) {
        this.ruleForm.id = res.data.id
        this.ruleFormCopy = _.cloneDeep(this.ruleForm)
        this.messageSettingCopy = _.cloneDeep(this.messageSetting)
        this.$emit('closeAndReset')
        this.$message.success('保存成功')
      }
      this.loading.save = false
    },
    /**
     * @function 修改任务名称，消息设置的标题自动生成为【任务名称-质检报告】，消息设置标题可修改
     */
    changeName() {
      if (this.ruleForm.name) {
        this.ruleForm.name = _.trim(this.ruleForm.name)
        this.messageSetting.title = `${this.ruleForm.name}-质检报告`
      }
    },
    /**
     * @function 获取质检源选项列表
     */
    async getQualityTask() {
      const res = await DataSourceService.list({
        pageno: 1,
        pagesize: 9999,
      })
      if (res && res.code === 0) {
        this.dataSourceList = res.data
      }
    },
    /**
     * @function 选择质检源，质检源绑定了标准库id，作为关联表查询条件
     */
    changeDataSource(id) {
      if (id) {
        this.ruleForm.standardId = _.get(_.find(this.dataSourceList, { id }), 'standardId')
      } else {
        this.ruleForm.standardId = ''
      }
    },
    /**
     * @function 获取cron表达式选项列表
     */
    async getCronList() {
      const dic = await this.getDic('CRONEXPRESSION')
      if (!_.isEmpty(dic)) {
        const res = await QualityTaskService.cron({
          skipCount: 0,
          maxResultCount: 999,
          dataCategoryId: dic.id,
        })
        if (res && res.code === 0) {
          this.cronList = res.data
        }
      }
    },
    // 获取数据源模型列表
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.code === 0) {
        this.standardList = res.data
      }
    },
    /**
     * @function 查询详情
     */
    async getInfo(id) {
      const res = await QualityTaskService.detail({ id })
      if (res && res.code === 0) {
        return res.data || {}
      }
      return {}
    },

    /**      基本信息 --end      */

    /**      关联表 --start      */

    /**
     * @function 查询实体树
     */
    async getTreeList() {
      if (!this.ruleForm.standardId) {
        this.$message.warning('请先选择质检源')
        return
      }
      const parameter = {
        standard_id: this.ruleForm.standardId,
        keyword: '',
        dynamic_column_name: '业务主题域',
      }
      const res = await StdClassTreeService.getTreeListNew(parameter)
      if (res && res.code === 0 && res.data) {
        this.treeData = res.data
        this.formatTreeData(this.treeData)
      }
    },
    /**
     * @function 改变树形实体数据结构
     */
    formatTreeData(data) {
      if (_.isEmpty(data)) {
        return []
      }
      const fn = (arr) => {
        _.forEach(arr, (o) => {
          o.children = o.childDynamic
          fn(o.children)
        })
      }
      fn(data)
    },
    /**
     * @function 关联表-选择业务主题域
     */
    changeRelation() {
      this.getRelationData()
    },
    /**
     * @function 查询关联表表格数据
     */
    async getRelationData() {
      let res
      // 查看时
      if (this.taskId) {
        this.loading.relationTable = true
        res = await QualityTaskService.getTaskAssociationTableList({
          taskId: this.ruleForm.id,
          keyword: this.relationSearch.keyword,
        })
      } else {
        // 新增或编辑时
        if (!this.ruleForm.standardId) {
          this.$message.warning('请选择质检源')
          return
        }
        this.loading.relationTable = true
        res = await QualityTaskService.getAssociationTableList({
          standardId: this.ruleForm.standardId,
          subjectDomainId: this.relationSearch.subjectDomainId,
          keyword: this.relationSearch.keyword,
        })
      }
      if (res && res.code === 0) {
        this.relationTableData = res.data
      }
      this.setCheckTable(this.ruleForm.details) // 设置选中状态
      this.loading.relationTable = false
    },
    /**
     * @function 获取字典
     */
    async getDic(code) {
      const res = await QualityTaskService.getDic({
        code,
      })
      if (res && res.code === 0) {
        return _.head(res.data) || {}
      }
      return {}
    },
    /**
     * @function 设置选中表格
     */
    setCheckTable(data) {
      this.$nextTick(() => {
        const ids = _.map(data, 'classId')
        this.checkRelationTable = []
        _.forEach(this.relationTableData, (item) => {
          if (_.includes(ids, item.id)) {
            item.isChecked = true
            this.checkRelationTable.push(item)
            this.$refs.relationTable.toggleCheckboxRow(item)
          }
        })
        this.relationTableData.sort((a, b) => {
          return !!b.isChecked - !!a.isChecked
        })
      })
    },
    /**
     * @function 勾选表格事件
     */
    async handleSelectionChange({ records, row, checked }) {
      this.checkRelationTable = records
      if (!_.isEmpty(this.checkRelationTable)) {
        let hasRule = true
        if (checked) {
          hasRule = await this.getTableRule(row.id)
        }
        if (!hasRule) {
          this.$message.warning('该表下不存在质检规则，请在质量规则配置模块进行配置')
          this.checkRelationTable = _.filter(this.checkRelationTable, (item) => {
            return item.id !== row.id
          })
          this.$refs.relationTable.setCheckboxRow([row], false)
          row.isChangeCheck = true
          return
        }
        this.ruleForm.details = _.map(this.checkRelationTable, (item) => {
          return {
            classId: item.id,
            tableName: item.tableName,
          }
        })
      } else {
        this.ruleForm.details = []
      }
    },
    /**
     * @function 业务主题域筛选
     */
    filterSelect(val) {
      this.filterText = val
    },
    /**
     * @function 业务主题域筛选
     */
    filterNode(value, data) {
      if (!value) return true
      const name = _.toLower(`${data.name}（${data.code}）`)
      return name.indexOf(_.toLower(value)) !== -1
    },
    /**
     * @function 查询关联表下是否存在规则
     * @returns true 存在规则   false 不存在规则
     */
    async getTableRule(classId) {
      const res = await QualityTaskService.getRuleListNew({
        class_ids: classId,
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        return true
      }
      return false
    },

    /**
     * @function 获取实体列表
     */
    async getEntityList() {
      const res = await QualityTaskService.getEntifyList({
        standard_id: this.ruleSearch.stdId,
        is_dict: 1,
        is_reference_data: 1,
      })
      if (res && res.code === 0) {
        this.entityList = res.data
        this.ruleSearch.entityId = _.get(_.head(res.data), 'id')
        this.getRuleList()
      }
    },
    /**
     * @function 查询规则列表
     */
    async getRuleList() {
      this.ruleTableData = []
      if (_.isEmpty(this.ruleForm.details)) {
        return
      }
      this.loading.ruleTable = true
      const res = await QualityTaskService.getRuleListNew({
        class_ids: _.join(_.map(this.ruleForm.details, 'classId'), ','),
        keyword: this.ruleSearch.keyword,
        rule_name: this.ruleSearch.ruleName,
      })
      if (res && res.code === 0) {
        this.ruleTableData = res.data
        // 查看的时候只需要显示已勾选的数据
        if (this.taskId) {
          const ids = _.map(this.ruleForm.ruleDetails, 'ruleId')
          this.ruleTableData = _.filter(res.data, (item) => {
            return _.includes(ids, item.ruleId)
          })
        }
      }
      this.setRuleCheckTable(this.ruleForm.ruleDetails) // 设置选中状态
      this.loading.ruleTable = false
    },
    // 获取规则类型
    async getRuleType() {
      const dic = await this.getDic('DATARULETYPE')
      const dicRes = await DataRuleSettingService.getRuleClass({
        skipCount: 0,
        maxResultCount: 999,
        dataCategoryId: dic.id,
      })
      if (dicRes && dicRes.data && dicRes.code === 0) {
        this.ruleTypeList = dicRes.data
      }
    },
    /**
     * @function 设置规则选中表格
     */
    setRuleCheckTable(data) {
      this.$nextTick(() => {
        const ids = _.map(data, 'ruleId')
        this.checkRuleTable = []
        _.forEach(this.ruleTableData, (item) => {
          if (_.includes(ids, item.ruleId)) {
            item.isChecked = true
            this.$refs.ruleTable.toggleCheckboxRow(item)
            this.checkRuleTable.push(item)
          }
        })
        this.ruleTableData.sort((a, b) => {
          return !!b.isChecked - !!a.isChecked
        })
      })
    },
    /**
     * @function 规则勾选表格事件
     */
    async selectRuleCheckbox({ records }) {
      this.checkRuleTable = records
      if (!_.isEmpty(this.checkRuleTable)) {
        this.ruleForm.ruleDetails = _.map(this.checkRuleTable, (item) => {
          return {
            classId: item.classId,
            ruleId: item.ruleId,
            classAttributeId: item.id,
          }
        })
      } else {
        this.ruleForm.ruleDetails = []
      }
    },

    /**      规则 --end      */

    /**      规则问题情况 --start      */

    /**
     * @function 查询规则问题/字段明细时间下拉菜单
     */
    async getProblemSelect() {
      const res = await QualityTaskService.getProblemSelect({
        pageno: 1,
        pagesize: 999,
        task_id: this.ruleForm.id,
      })
      if (res && res.code === 0) {
        this.runRecordList = res.data
        if (this.activeName === 'problem') {
          _.assign(this.problemSearch, {
            select: _.head(res.data),
            dataQualityTaskId: _.get(_.head(res.data), 'dataQualityTaskId'),
            taskRunId: _.get(_.head(res.data), 'id'),
          })
        } else if (this.activeName === 'field') {
          this.fieldSearch.select = _.head(res.data)
        }
      }
    },
    /**
     * @function 修改下拉菜单绑定值
     */
    changeProblemSelect(val) {
      _.assign(this.problemSearch, {
        dataQualityTaskId: val ? val.dataQualityTaskId : '',
        taskRunId: val ? val.id : '',
      })
      this.getProblemList()
      this.$forceUpdate()
    },
    /**
     * @function 查询规则问题情况列表
     */
    async getProblemList() {
      this.problemTableData = []
      if (!this.problemSearch.taskRunId) {
        this.$message.warning('请选择任务')
        return
      }
      this.loading.ruleProblemTable = true
      const res = await QualityTaskService.getProblemList({
        pageno: this.problem.pageNo,
        pagesize: this.problem.pageSize,
        dataQualityTaskId: this.problemSearch.dataQualityTaskId,
        taskRunId: this.problemSearch.taskRunId,
        keyword: this.problemSearch.keyword,
      })
      if (res && res.code === 0) {
        this.problemTableData = res.data
        if (res.page) {
          this.problem.total = res.page.recordCount
        } else if (res.data) {
          this.problem.total = res.data.length
        } else {
          this.problem.total = 0
        }
      }
      this.loading.ruleProblemTable = false
    },
    problemPageChange() {
      this.getProblemList()
    },
    problemSizeChange() {
      this.getProblemList()
    },
    fieldPageChange(val) {
      this.field.pageNo = val
      this.getFieldDetail()
    },
    fieldSizeChange(val) {
      this.field.pageSize = val
      this.getFieldDetail()
    },
    /**
     * @function 规则问题情况、字段明细情况选中行
     */
    changeDetail(val) {
      this.currentDetail = val
    },
    /**
     * @function 规则问题情况、字段明细情况详情
     * @type read：只读，add：新增，edit：编辑
     * @routerType 0：规则问题情况，1：字段明细情况
     */
    async openDetail(type, routerType) {
      if (!this.currentDetail) {
        this.$message.warning('请选择数据')
        return
      }
      if (this.problemSearch.select) {
        this.currentDetail.date = this.problemSearch.select.endTime
          ? dayjs(this.problemSearch.select.endTime).format('YYYY-MM')
          : ''
      }
      if (this.fieldSearch.select) {
        this.currentDetail.date = this.fieldSearch.select.endTime
          ? dayjs(this.fieldSearch.select.endTime).format('YYYY-MM-DD')
          : ''
      }
      let taskRunId = null
      if (this.activeName === 'problem') {
        taskRunId = this.problemSearch.taskRunId
      } else if (this.activeName === 'field') {
        taskRunId = this.fieldSearch.select.id
      }
      await localforage.setItem('taskItem', this.currentDetail)
      this.$router.push({
        path: `${this.basePath}/legacy-resource/data-quality-manage/quality-task-detail?taskId=${this.currentDetail.id}&type=${routerType}&taskRunId=${taskRunId}&detailId=${this.detailId}`,
      })
    },
    /**
     * @function 导出规则问题情况-列表
     */
    async exportRuleInfoList() {
      if (this.runRecordList.length === 0) {
        this.$message.info('没有任务记录，不能导出')
        return
      }
      const res = await QualityTaskService.exportRuleInfoList({
        pageno: 1,
        pagesize: 999,
        dataQualityTaskId: this.problemSearch.dataQualityTaskId,
        taskRunId: this.problemSearch.taskRunId,
        keyword: this.problemSearch.keyword,
      })
      if (res && res.code === 0 && res.url) {
        window.open(`${this.currentEnv.VUE_APP_STANDARD_SERVER}/${res.url}`, '_blank')
      }
    },
    /**
     * @function 查看质检报告
     */
    readTaskReport() {
      let taskRunId = null
      if (this.activeName === 'problem') {
        taskRunId = this.problemSearch.taskRunId
      } else if (this.activeName === 'field') {
        taskRunId = this.fieldSearch.select.id
      }
      this.$router.push(
        `${this.basePath}/legacy-resource/data-quality-manage/task-report?taskId=${this.taskId}&taskRunId=${taskRunId}`
      )
    },
    /**      规则问题情况 --end      */

    /**      字段明细情况 --start      */
    /**
     * @function 查询字段明细情况列表
     * @taskRunId 执行任务id
     * @classId 类别id
     * @keyword 关键字
     */
    async getFieldDetail() {
      this.fieldTableData = []
      if (!this.fieldSearch.select) {
        this.$message.warning('请选择任务')
        return
      }
      this.loading.fieldTable = true
      const res = await QualityTaskService.getField({
        taskRunId: this.fieldSearch.select.id,
        classId: this.fieldSearch.bank,
        keyword: this.fieldSearch.keyword,
        pageNo: this.field.pageNo,
        pageSize: this.field.pageSize,
      })
      if (res && res.data && res.code === 0 && res.data) {
        this.fieldHeader = res.data.columnName
        this.fieldTableData = res.data.data
        _.forEach(this.fieldTableData, (item) => {
          item.emptyCheck =
            _.get(_.find(item.problemList, ['ruleName', '空值检查']), 'problemCount') || 0
          item.citationCheck =
            _.get(_.find(item.problemList, ['ruleName', '引用检查']), 'problemCount') || 0
          item.repeatCheck =
            _.get(_.find(item.problemList, ['ruleName', '重复数据检查']), 'problemCount') || 0
          item.specificationCheck =
            _.get(_.find(item.problemList, ['ruleName', '规范检查']), 'problemCount') || 0
        })
        if (res.page) {
          this.field.total = res.page.recordCount
        } else if (res.data.data) {
          this.field.total = res.data.data.length
        } else {
          this.field.total = 0
        }
      }
      this.loading.fieldTable = false
      this.$nextTick(() => {
        this.$refs.fieldTable.doLayout()
      })
    },

    /**
     * @function 查询规则问题情况下拉菜单
     */
    async getFieldSelect() {
      const id = this.detailInfo ? this.detailInfo.id : this.taskId
      const bank = await this.getInfo(id)
      this.classBank = _.map(bank.details, (i) => {
        return i
      })
      this.fieldSearch.bank = _.get(this.classBank[0], 'classId')
    },
    /**
     * @function 导出字段明细问题情况-列表
     */
    async exportFieldInfoList() {
      if (this.runRecordList.length === 0) {
        this.$message.info('没有任务记录，不能导出')
        return
      }
      const res = await QualityTaskService.exportFieldInfoList({
        pageno: 1,
        pagesize: 999,
        taskRunId: this.fieldSearch.select.id,
        classId: this.fieldSearch.bank,
        keyword: this.fieldSearch.keyword,
      })
      if (res && res.code === 0 && res.url) {
        window.open(`${this.currentEnv.VUE_APP_STANDARD_SERVER}/${res.url}`, '_blank')
      }
    },
    /**      字段明细情况 --end      */

    /**
     * @function 初始化详情
     */
    async initData() {
      if (this.taskId || _.includes(['read', 'edit'], this.type)) {
        this.detailId = this.detailInfo ? this.detailInfo.id : this.taskId
        this.ruleForm = await this.getInfo(this.detailId)
        this.ruleFormCopy = _.cloneDeep(this.ruleForm)
        this.messageSetting = {
          ...this.ruleForm.messageSetting,
          recipient: this.ruleForm.recipient,
          isSendDetails: !this.ruleForm.messageSetting.isSendDetails,
        }
        this.messageSettingCopy = _.cloneDeep(this.messageSetting)
      }
    },
    // 关联表行点击事件
    handleRowDblClick({ row }) {
      this.relationTableDataCurrentRow = row
      this.getAttrList()
      this.getConditionList()
      this.dialogVisible = true
      this.inputData = row.checkTableFilters || []
      this.getSettingList()
      // console.log(row, 'row')
    },
    // 新增输入字段
    addInputCode() {
      this.inputData.push({})
    },
    // 删除输入字段
    deleteInputCode(row) {
      this.$confirm('是否确定要删除该字段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.inputData = _.difference(this.inputData, [row])
          this.$message.success('删除成功')
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    // 获取设置属性列表
    async getSettingList() {
      const res = await QualityTaskService.getCheckTableFilterList({
        ClassId: this.relationTableDataCurrentRow.id,
        stdDataQualityTaskId: this.detailInfo.id,
      })
      if (res && res.code === 0) {
        this.inputData = []
        this.inputData = res.data
      }
    },
    // 获取属性列表
    async getAttrList() {
      const res = await stdClassListService.getAttrList({
        class_id: this.relationTableDataCurrentRow.id,
      })
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data
      }
    },
    // 获取条件下拉数据
    async getConditionList() {
      const res = await QualityTaskService.getOperatorList()
      if (res && res.code === 0) {
        this.conditionList = res.data
      }
    },
    // 保存设置属性
    saveSettings() {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.inputData.length; i++) {
        const item = this.inputData[i]
        console.log(item, item.classAttributeId, item.operator, item.text, 'item')
        if (!item.classAttributeId) {
          this.$message.warning(`第${i + 1}行的属性名称不能为空`)
          return
        }
        if (!item.operator && item.operator !== 0) {
          this.$message.warning(`第${i + 1}行的条件不能为空`)
          return
        }
        if (!item.text) {
          this.$message.warning(`第${i + 1}行的值不能为空`)
          return
        }
      }
      this.relationTableDataCurrentRow.checkTableFilters = this.inputData
      this.ruleForm.details = this.relationTableData
      this.dialogVisible = false
    },
  },
  async created() {
    this.initData()
    this.getCronList() // 获取cron表达式下拉
    this.getQualityTask() // 获取质检源下拉
    this.getStandardList() // 获取数据源模型下拉
  },
  activated() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
}
</script>
<style lang="scss" scoped>

#qualityTaskForm {
  /deep/ .el-tabs__content {
    height: calc(100% - 51px);
  }
  .close {
    float: right;
    font-size: 20px;
    cursor: pointer;
  }
  .table-height {
    height: calc(100% - 125px);
  }
  /deep/ .cell-center {
    display: table-cell;
    vertical-align: inherit;
  }
}
/deep/ .is--disabled.vxe-cell--checkbox .vxe-checkbox--icon:before {
  background-color: #9e9e9e;
}

</style>
